export default "__VITE_ASSET__4af7b6e8__"